import { Routes } from "@angular/router";
import { LoginGuard } from "@core/guard/login-guard.guard";

export const proveedoresRoutes: Routes = [
  {
    path: "prv_inicio",
    loadComponent: () => import("./inicio/inicio-proveedores.component"),
    data: {
      codmod: "PRV",
      icon: "home",
    },
  },
  {
    path: "prv_gestion-usuarios",
    loadChildren: () =>
      import("./gestion-usuarios/gestion-usuarios.routes").then((m) => m.gestionUsuariosRoutes),
    data: {
      codmod: "PRV",
      icon: "group",
    },
  },
  {
    path: "prv_usuarios-internos",
    loadChildren: () =>
      import("./usuarios-internos/usuarios-internos.routes").then((m) => m.usuariosInternosRoutes),
    data: {
      codmod: "PRV",
      icon: "assignment_ind",
    },
  },
  {
    path: "prv_consulta-ingresos",
    loadComponent: () => import("./consulta-ingresos/consulta-ingresos.component"),
    data: {
      codmod: "PRV",
      icon: "login",
    },
  },
  {
    path: "prv_consulta-facturas",
    loadChildren: () =>
      import("./consulta-facturas/consulta-facturas.routes").then((m) => m.consultaFacturasRoutes),
    data: {
      codmod: "PRV",
      icon: "receipt_long",
    },
  },
  {
    path: "prv_gestion-facturas",
    loadChildren: () =>
      import("./gestion-facturas/gestion-facturas.routes").then((m) => m.gestionFacturasRoutes),
    data: {
      codmod: "PRV",
      icon: "receipt",
    },
  },
  {
    path: "prv_notificaciones",
    loadComponent: () => import("./notificaciones/notificaciones.component"),
    data: {
      codmod: "PRV",
      icon: "notifications",
    },
  },
  {
    path: "prv_contabilizacion",
    loadChildren: () =>
      import("./contabilizacion/contabilizacion.routes").then((m) => m.contabilizacionRoutes),
    data: {
      codmod: "PRV",
      icon: "request_quote",
    },
  },
  {
    path: "prv_mensajeria",
    loadChildren: () =>
      import("./mensajeria/mensajeria.routes").then(
        (m) => m.mensajeriaRoutes
      ),
    data: {
      codmod: "PRV",
      icon: "chat",
    },
  },
];
